export class StoredValue {
	constructor(key, defaultValue, store=null) {
		this.key = key;
		this.defaultValue = defaultValue;
		this.store = store;
		if (null==this.store) {
			this.store = sessionStorage;
		}
	}
	get value() {
		if (!this._v) {
			this._v = this.store.getItem(this.key);
		}
		if (!this._v) {
			return this.defaultValue;
		}
		return this._v;
	}
	set value(v) {
		this._v = v;
		this.store.setItem(this.key, v);
	}
}